// extracted by mini-css-extract-plugin
export default {"infoBox":"styles_infoBox__qu+kP","imageSection":"styles_imageSection__LStuY","header":"styles_header__wpvJa","description":"styles_description__8XBvI"};